// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/FieldRestrictionSet.yaml
// Generated: 2026-02-20T15:39:03.012Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateFieldRestrictionSet, UpdateFieldRestrictionSet, FieldRestrictionSet } from '@/types/core/FieldRestrictionSet';

/**
 * FieldRestrictionSet Service
 * CRUD operations for FieldRestrictionSet via the ABP API.
 */
export const fieldRestrictionSetService = new EntityService<FieldRestrictionSet, CreateFieldRestrictionSet, UpdateFieldRestrictionSet>(
  '/api/core/fieldrestrictionset',
  'FieldRestrictionSet',
);
